import React from 'react';
import {Accordion, AccordionTheme, Divider, Text} from 'wix-ui-tpa/cssVars';
import {FormModel} from '../../../../../../domain/models/checkout/Cart/Form.model';
import {classes} from './AdditionalDetailsStepOpen.st.css';

export enum AdditionalDetailsFormDataHook {
  formItem = 'AdditionalDetailsForm.formItem',
  formItemAccordion = 'AdditionalDetailsForm.formItemAccordion',
  formItemSubtitle = 'AdditionalDetailsForm.formItemSubtitle',
}

export const AdditionalDetailsForm: React.FC<{form: FormModel}> = ({form}) => {
  const {id, title, description} = form;

  return (
    <li className={classes.eventItem} data-hook={AdditionalDetailsFormDataHook.formItem}>
      <Accordion
        data-hook={AdditionalDetailsFormDataHook.formItemAccordion}
        theme={AccordionTheme.Box}
        initiallyExpanded={[id]}>
        <Accordion.Item
          id={id}
          key={id}
          title={title}
          suffix={
            description?.length > 0 ? (
              <Text data-hook={AdditionalDetailsFormDataHook.formItemSubtitle}>{description.join('\n')}</Text>
            ) : undefined
          }>
          <Divider />
        </Accordion.Item>
      </Accordion>
    </li>
  );
};
